/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { UpdateUserTagOptions, UpdateUserTagResponses } from '../types/UpdateUserTag'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description Updates the user's tag list with the given tags. MARKET_MAKER-tagged users are exempt from the tenant trade limit and asset position restriction on POST /v1/orders.
 * @summary Update a user's tag list (admin-only)
 * {@link /v1/user/:user_id/tag}
 */
export function updateUserTag<ThrowOnError extends boolean = true>(
  options: Options<UpdateUserTagOptions, ThrowOnError>,
): Unwrappable<RequestResult<UpdateUserTagResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'PUT',
      url: '/v1/user/{user_id}/tag',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<UpdateUserTagResponses, ThrowOnError>>,
  )
}
